module.exports = __webpack_public_path__ + "assets/img/inning_tabs_wrap_list_border.png?8d2070f674e87c7a845939841258dfd9";